import Gooey, {
  mount,
  Component,
  model,
  calc,
  IntrinsicObserver,
} from '@srhazi/gooey';

interface FocusObserver {
  children?: JSX.Element[] | JSX.Element;
}
const FocusListener: Component<FocusObserver> = (
  { children },
  { onMount, onUnmount }
) => {
  const state = model({ hasFocus: false });
  let childEls: Element[] = [];

  function updateHasFocus() {
    state.hasFocus = childEls.some((el) => el.contains(document.activeElement));
  }

  return (
    <fieldset>
      <legend>Has focus: {calc(() => (state.hasFocus ? 'yes' : 'no'))}</legend>
      <IntrinsicObserver
        elementCallback={(element, event) => {
          if (event === 'mount' && element instanceof HTMLElement) {
            childEls.push(element);
            element.addEventListener('focusin', updateHasFocus);
            element.addEventListener('focusout', updateHasFocus);
          }
          if (event === 'unmount' && element instanceof HTMLElement) {
            childEls = childEls.filter((el) => el !== element);
            element.removeEventListener('focusin', updateHasFocus);
            element.removeEventListener('focusout', updateHasFocus);
            updateHasFocus();
          }
        }}
      >
        {children}
      </IntrinsicObserver>
    </fieldset>
  );
};

const App: Component<{}> = (_props, { onMount }) => {
  const state = model({ isShowing: true });

  onMount(() => {
    const handle = setInterval(() => {
      state.isShowing = !state.isShowing;
    }, 1000);
    return () => clearInterval(handle);
  });

  return (
    <>
      <h4>IntrinsicObserver demo</h4>
      <FocusListener>
        <p>
          Here is some text with a <input type="text" value="text input" />
        </p>
      </FocusListener>
      <p>
        Some text outside a focus listener with a{' '}
        <input type="text" value="text input" />
      </p>
      <FocusListener>
        <>
          <p>
            More things <input type="text" value="to focus on" />
          </p>
          {calc(() =>
            state.isShowing ? (
              <p>
                Dynamic item <a href="#">with a link</a>
              </p>
            ) : (
              <p>But the link disappears</p>
            )
          )}
          <p>
            More items{' '}
            <label>
              <input type="checkbox" /> to interact with
            </label>
          </p>
        </>
      </FocusListener>
    </>
  );
};

mount(document.getElementById('intrinsicobserver.tsx')!, <App />);
